import { FC } from 'react';
import { Helmet } from 'react-helmet-async';
import { useIntl } from 'react-intl';
import cn from 'classnames';

import { PageTitle } from '@app/components';
import { sharedMessages } from '@app/translations';

import { LocaleDropdown } from './LocaleDropdown';

import css from './PreferencesPage.module.scss';

export const PreferencesPage: FC = () => {
  const { $t } = useIntl();

  return (
    <>
      <Helmet>
        <title>
          {$t({
            id: 'preferences.documentTitle',
            defaultMessage: 'Preferences - EBSCO Locate',
          })}
        </title>
      </Helmet>
      <div
        className={cn(css.container, 'container')}
        data-auto="preferences-container"
      >
        <PageTitle>{$t(sharedMessages.preferences)}</PageTitle>
        <LocaleDropdown className={css.localeDropdown} />
      </div>
    </>
  );
};
